@if ( request().document.inventory_action_for_consume ) {
  <div class="subtitle" style="margin-bottom: 10px;">
    @if (request()?.completed_at) {
      Detalle de {{request().document.base_type | human}} #{{request().document.correlative_id}}
    }
    @else {
      Introducir el detalle de {{request().document.base_type | human}} #{{request().document.correlative_id}}
    }
  </div>
  <app-inventory-action-form
    [parentFormGroup]="form"
    [brandId]="request()?.document?.object?.brand?.id"
    [requirementId]="request()?.document?.requirement_id"
    [checkForDiscounts]="true"
    [enableDiscounts]="true"
    [isReadOnly]="request()?.completed_at"
    (dataChanged)="updateInventoryAction()"
  >
  </app-inventory-action-form>
}
